/**
 * Closes all open mega menu instances and optionally removes the active state from the header
 *
 * @param {boolean} [includeHeader=false] - Whether to also remove the 'mega-menu-is-active' class from the header element
 */
function closeAllMenus(includeHeader = false) {
  document.querySelectorAll('.wp-block-rothschild-mega-menu-block__menu-button').forEach((btn) => {
    btn.setAttribute('aria-expanded', false);
    if (!includeHeader) {
      return;
    }
    const header = btn?.closest('header.mega-menu-is-active');
    if (!header) {
      return;
    }
    header?.classList?.remove('mega-menu-is-active');
  });
}

/**
 * Opens a specific mega menu and adds the active state to the header
 *
 * @param {HTMLElement} menuButton - The menu button element that triggered the menu
 */
function openMenu(menuButton) {
  menuButton.setAttribute('aria-expanded', true);
  const header = menuButton?.closest('header.wp-block-template-part');
  if (!header) {
    return;
  }
  header?.classList?.add('mega-menu-is-active');
}

const els = document.querySelectorAll('.wp-block-rothschild-mega-menu-block');
els.forEach((el) => {
  const menuButton = el.querySelector('.wp-block-rothschild-mega-menu-block__menu-button');
  if (!menuButton) {
    return;
  }

  const menuId = menuButton.getAttribute('aria-controls');
  const menuContainer = document.getElementById(menuId);

  // handle menu button keydowns
  menuButton.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    closeAllMenus(true);
  });

  menuContainer.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    closeAllMenus(true);
    menuButton.focus();
  });

  menuButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    const expanded = menuButton.getAttribute('aria-expanded') === 'true';

    if (!expanded) {
      closeAllMenus();
      openMenu(menuButton);
    } else {
      closeAllMenus(true);
    }
  });
});

document.addEventListener('click', (event) => {
  if (event.target.closest('.wp-block-rothschild-mega-menu-block')) {
    return;
  }
  closeAllMenus(true);
});

document.addEventListener('focusin', (event) => {
  if (event.target.closest('header.mega-menu-is-active')) {
    return;
  }
  closeAllMenus(true);
});
